import Cookies from "js-cookie"
import {
    BR_UID_DEFAULT_VALUE,
    SearchApiRequestTypes,
    BR_MT_SEARCH,
    BR_UID_2,
    BR_SEGMENT_ID,
} from "../../config/constants"
import {ExternalSearchApiResponse, SearchApiRequest} from "../../models/searchApi"
import {BloomreachCookiesInitialVal} from "../../models/SearchState"
import {IS_BROWSER} from "../window"

interface buildProductsRequestParameters {
    url: string
    searchTerm: string | null
    type: SearchApiRequestTypes
    start: number
    pageSize: number
    bloomreachCookiesInitialVal: BloomreachCookiesInitialVal
    bloomreachPersonalizationEnabled: boolean
    pageLoadTrigger: string
    sliceSize: number
    fields?: (keyof ExternalSearchApiResponse)[]
    productSummaryTemplateName?: string
    imageRatio?: string
    bloomreachDefaultProviderArgs: string
}
const buildProductsRequestParams = ({
    url,
    searchTerm,
    type,
    start,
    pageSize = 24,
    bloomreachPersonalizationEnabled,
    bloomreachCookiesInitialVal,
    pageLoadTrigger,
    sliceSize,
    fields,
    productSummaryTemplateName = "",
    imageRatio = "",
    bloomreachDefaultProviderArgs,
}: buildProductsRequestParameters): SearchApiRequest => {
    const params = new SearchApiRequest()

    let bloomreachCookieMT = ""
    let bloomreachCookieUID = ""
    let bloomreachCookieSegIdVal = ""
    if (bloomreachPersonalizationEnabled) {
        if (!IS_BROWSER()) {
            bloomreachCookieMT = bloomreachCookiesInitialVal.brMtSearch || bloomreachDefaultProviderArgs
            bloomreachCookieUID = bloomreachCookiesInitialVal.brUid2
            bloomreachCookieSegIdVal = bloomreachCookiesInitialVal.brSegId
        } else {
            bloomreachCookieMT = Cookies.getJSON(BR_MT_SEARCH) || bloomreachDefaultProviderArgs
            bloomreachCookieUID = Cookies.getJSON(BR_UID_2) || BR_UID_DEFAULT_VALUE
            bloomreachCookieSegIdVal = Cookies.getJSON(BR_SEGMENT_ID) || ""
        }
        params.contextid = bloomreachCookieUID
        params.providerArgs = bloomreachCookieMT
        params.segment = bloomreachCookieSegIdVal
    }

    params.start = start
    params.pagesize = pageSize
    params.searchTerm = searchTerm ?? ""
    params.type = type
    params.criteria = url
    params.fields = fields ? fields.join() : null
    params.showSearchProviderRequestUrl = url.includes("showSearchProviderRequestUrl=true")
    params.pageLoadTrigger = pageLoadTrigger
    params.sliceSize = sliceSize
    params.productSummaryTemplateName = productSummaryTemplateName
    params.imageRatio = imageRatio
    return params
}

export default buildProductsRequestParams
